/**
 * Input Component
 * Text input with label, error handling, and help text
 */
export default function Input({
  label,
  error,
  helpText,
  className = '',
  id,
  type = 'text',
  ...props
}) {
  const inputId = id || `input-${Math.random().toString(36).substr(2, 9)}`
  
  return (
    <div className={className}>
      {label && (
        <label htmlFor={inputId} className="label">
          {label}
        </label>
      )}
      <input
        id={inputId}
        type={type}
        className={`input ${error ? 'input-error' : ''}`}
        {...props}
      />
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
      {helpText && !error && (
        <p className="mt-1 text-sm text-gray-500">{helpText}</p>
      )}
    </div>
  )
}

// Textarea variant
Input.Textarea = function InputTextarea({ label, error, className = '', id, rows = 4, ...props }) {
  const inputId = id || `textarea-${Math.random().toString(36).substr(2, 9)}`
  
  return (
    <div className={className}>
      {label && (
        <label htmlFor={inputId} className="label">
          {label}
        </label>
      )}
      <textarea
        id={inputId}
        rows={rows}
        className={`input ${error ? 'input-error' : ''}`}
        {...props}
      />
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
    </div>
  )
}

// Select variant
Input.Select = function InputSelect({ label, error, className = '', id, children, ...props }) {
  const inputId = id || `select-${Math.random().toString(36).substr(2, 9)}`
  
  return (
    <div className={className}>
      {label && (
        <label htmlFor={inputId} className="label">
          {label}
        </label>
      )}
      <select
        id={inputId}
        className={`input ${error ? 'input-error' : ''}`}
        {...props}
      >
        {children}
      </select>
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
    </div>
  )
}